export default {
	title: "BETA",
};
